<template>
  <div class="privacy-container">
    <section class="privacy-content">
      <h1>개인정보처리방침 (Privacy Policy)</h1>
      <p class="update-date">최종 수정일: 2026년 4월 25일</p>

      <h2>1. 개인정보의 수집항목 및 수집방법</h2>
      <p>Happy Dongtan은 별도의 회원가입 없이 서비스를 이용하실 수 있으며, 사용자의 개인정보를 직접 수집하거나 저장하지 않습니다.</p>

      <h2>2. 구글 애드센스 및 쿠키 사용</h2>
      <p>
        본 사이트는 Google에서 제공하는 광고 서비스인 '구글 애드센스'를 이용합니다. 
        Google을 포함한 제3자 제공업체는 쿠키를 사용하여 사용자의 이전 웹사이트 방문 기록을 바탕으로 광고를 게재합니다. 
        Google의 광고 쿠키를 사용함으로써 Google과 파트너는 사용자의 본 사이트 및 다른 사이트 방문 기록을 토대로 적절한 광고를 게재할 수 있습니다.
      </p>
      <p>
        사용자는 <a href="https://adssettings.google.com/authenticated" target="_blank">Google 광고 설정</a>을 통해 맞춤형 광고를 해제할 수 있습니다. 
        또는 <a href="https://www.aboutads.info/choices" target="_blank">www.aboutads.info</a>를 방문하여 맞춤형 광고를 위해 제3자 제공업체가 사용하는 쿠키를 차단할 수 있습니다.
      </p>

      <h2>3. 쿠키(Cookie)의 운용 및 거부</h2>
      <p>
        쿠키는 웹사이트를 운영하는데 이용되는 서버가 사용자의 브라우저에 보내는 아주 작은 텍스트 파일입니다. 
        사용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있으나, 이 경우 서비스 이용에 일부 제한이 있을 수 있습니다.
      </p>

      <h2>4. 타 사이트 링크</h2>
      <p>본 사이트는 외부 웹사이트로의 링크를 포함할 수 있습니다. 링크된 사이트의 개인정보처리방침은 해당 사이트의 규정을 따릅니다.</p>

      <h2>5. 개인정보 보호책임자</h2>
      <p>문의사항이 있으시면 아래 이메일로 연락 주시기 바랍니다.<br>Email: infiniblue@naver.com</p>
      
      <!-- Bottom Ad Unit -->
      <AdComponent slotId="9173007135" />
    </section>
  </div>
</template>

<style scoped>
.privacy-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 100px 22px;
  line-height: 1.7;
}
.update-date {
  color: var(--text-secondary);
  margin-bottom: 40px;
}
h2 {
  margin-top: 40px;
  font-size: 1.5rem;
}
a {
  color: var(--accent);
  text-decoration: none;
}
</style>
